module.exports = __webpack_public_path__ + "static/media/location_block.5dd0a99c.svg";